import axios from 'axios';
import { clearTechAxios } from '../http-common';
import { getUTMParameters } from './cookieUtils';

export enum FM_ACTIONS {
  pageview = 'pageview',
  click = 'click',
}

export const sendFunnelMetrics = (
  category: string,
  action: FM_ACTIONS,
  label: string,
  value: string
): void => {
  axios({
    method: 'get',
    url: '/funnelmetrics',
    params: {
      category,
      action,
      label,
      value,
      original_referrer: document ? document.referrer : null,
      ...getUTMParameters(),
    },
  }).catch((error) => {
    console.warn('Warning: Funnelmetrics failed', error);
  });
};

export const sendFunnelMetricsClearTech = (
  category: string,
  action: FM_ACTIONS,
  label: string,
  value: string
): void => {
  clearTechAxios({
    method: 'get',
    url: '/funnelmetrics',
    params: {
      category,
      action,
      label,
      value,
      original_referrer: document ? document.referrer : null,
    },
  }).catch((error) => {
    console.warn('Warning: Funnelmetrics failed', error);
  });
};

export const render404Page = (): { notFound: true } => {
  return {
    notFound: true,
  };
};

export const returnNoProps = (): { props: Record<string, string> } => {
  return {
    props: {
      // nothing
    },
  };
};

export const returnNoPaths = () => {
  return {
    paths: [],
    fallback: false,
  };
};
